<div class="digitalKit_container">
    <header class="digital_header">
        <h2 class="header_title">Programa Kit Digital: Digitalizar tu organización ya no es una opción</h2>
    </header>
    <section class="first_paragraph">
        <img class="kitDigital_logo" src="../../../../assets/img/logo-kitDigital.png" alt="kitDigital_logo">
        <p class="title_paragraph">¿En que consiste el programa kit digital?</p>
        <p>
            El programa kit digital es una ayuda que forma parte del Plan de Recuperación, 
            Transformación y Resiliecia, la agenda España Digital 2025 y el del Plan de Digitalización de Pymes. 
            Su finalidad es apoyar a Pymes, Microempresas y autónomos en todo el proceso de transformación 
            digital para que puedan adquirir soluciones digitales necesarias y, aumentar su productividad, 
            destacar frente a su competencia y sobrevivir ante cualquier cambio en el mercado.
        </p>
        <p>
            Las bases reguladoras del programa Kit Digital ya están publicadas, ahí podrás conocer con más 
            detalle cuál será el funcionamiento del Kit Digital. Lo que sí podemos adelantarte es que durante 
            el periodo de 2021 y 2023 se irán publicando varias convocatorias de ayudas que podrán beneficiarse 
            los diferentes segmentos de Pymes, Microempresas y autónomos que detallamos en el siguiente apartado.
        </p>
    </section>
    <section class="second_paragraph">
        <p class="title_paragraph">¿Cómo se repartirá el importe del programa Kit Digital?</p>
        <p>
            A este programa se le ha ajuntado un presupuesto de mas de <strong>3.000 millones de euros                
            </strong> y, está financiado por la Unión Europea a través de los fondos Next Generation EU, todo este 
            importe se repartirá en dos fases, por un lado <strong>500 millones de euros para Pymes y, 
            en la segunda fase se proporcionarán 2.500 millones de euros a microempresas y autónomos.</strong>
        </p>
        <a class="text_link" href="">La primera fase esá prevista que vea la luz a principios de 2022.</a>
        <p class="sec_p">
            En este sentido, el programa Kit Digital se dividirá en bonos digitales con un importe 
            máximo dependiendo del número de trabajadores que tenga tu empresa, quedando la segmentación 
            de beneficiarios de la siguiente forma:
        </p>
    </section>
    <section class="third_paragraph">
        <div>
            <h3>Segmento 1</h3>
            <p>Pymes que cuenten con un número de empleados de entre 10 y menos de 50, recibirán un bono digital con el importe máximo de 12.000€.</p>
            <h3>Segmento 2</h3>
            <p>Pymes o Microempresas de entre 3 y menos de 10 trabajadores, el importe máximo del bono digital será de 6.000€.</p>
            <h3>Segmento 3</h3>
            <p>Pymes o Microempresas con 1 o 2 empleados y personas autónomas podrán obtener un bono digital con 2.000€ como importe máximo.</p>
        </div>
        <img class="img_thirdParagraph" src="../../../../assets/img/imagenOffice.png" alt="section_image">
    </section>
    <a href="https://www.acelerapyme.gob.es/kit-digital"><button class="btn_rounded">Guía programa kit digital</button></a>
    <section class="second_paragraph">
        <p class="title_paragraph">¿En qué soluciones puedes canjear tu bono digital?</p>
        <div *ngFor="let item of dropdownCard">
            <app-info-drop-down [dropdownCard]="item"></app-info-drop-down>
        </div>
    </section>
    <section class="second_paragraph">
        <app-info-card [infoCard]="infoCard"></app-info-card>
    </section>
    <img src="../../../../assets/svg/Logo-digitalizadores-01.svg" alt="logos_gob">
</div>


